module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseContainer', {
    staticClass: "dnnCloud-order-box",
    attrs: {
      "loading": _vm.listLoading,
      "isHasPageFt": !_vm.listLoading
    },
    scopedSlots: _vm._u([{
      key: "hd",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 18
          }
        }, [_c('el-form', {
          attrs: {
            "inline": true,
            "model": _vm.souchs
          },
          nativeOn: {
            "submit": function($event) {
              $event.preventDefault();
            }
          }
        }, [_c('el-form-item', [_c('el-input', {
          staticStyle: {
            "width": "180px"
          },
          attrs: {
            "placeholder": "用户名",
            "clearable": ""
          },
          on: {
            "change": function($event) {
              return _vm.getList(1)
            }
          },
          nativeOn: {
            "keyup": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.getList(1)
            }
          },
          model: {
            value: (_vm.userName),
            callback: function($$v) {
              _vm.userName = $$v
            },
            expression: "userName"
          }
        })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
          attrs: {
            "type": "primary",
            "size": "medium"
          },
          on: {
            "click": function($event) {
              return _vm.getList(1)
            }
          }
        }, [_vm._v("查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 3
          }
        }, [_c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("提交任务数：" + _vm._s(_vm.totalCount))])]), _vm._v(" "), _c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 3
          }
        }, [_c('div', {
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("生图成功数：" + _vm._s(_vm.successCount))])])]
      },
      proxy: true
    }, {
      key: "main",
      fn: function() {
        return [_c('el-table', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "data": _vm.dataList,
            "highlight-current-row": "",
            "height": _vm.maxTbHeight,
            "header-cell-style": _vm.getRowClass
          },
          on: {
            "row-dblclick": _vm.handleRowClick
          }
        }, [_c('el-table-column', {
          attrs: {
            "type": "index",
            "index": _vm.indexMethod,
            "label": "序号",
            "width": "80"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s((_vm.pageNumber - 1) * _vm.pageSize + scope.$index + 1))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "userName",
            "label": "用户名",
            "min-width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.userId ? scope.row.userName : "-"))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "companyname",
            "label": "企业",
            "min-width": "240",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.companyname || "-"))])]
            }
          }])
        }), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "prop": "resolution",
            "label": "图片大小",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.resolution || "-"))])]
            }
          }], null, false, 3404415237)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "通道图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.modelImgThumbnail || scope.row.modelImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.modelImgThumbnail || scope.row.modelImg,
                  "preview-src-list": [scope.row.modelImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }], null, false, 2834397069)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "原图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.originalImgThumbnail || scope.row.originalImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.originalImgThumbnail || scope.row.originalImg,
                  "preview-src-list": [scope.row.originalImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }], null, false, 551977147)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "叠加优化图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(
                scope.row.optimizationImgThumbnail || scope.row.optimizationImg
              ) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.optimizationImgThumbnail || scope.row.optimizationImg,
                  "preview-src-list": [scope.row.optimizationImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }], null, false, 209977539)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "原图优化图",
            "width": "110",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.satelliteImgThumbnail || scope.row.satelliteImg) ? _c('el-image', {
                staticStyle: {
                  "height": "37px",
                  "width": "auto"
                },
                attrs: {
                  "src": scope.row.satelliteImgThumbnail || scope.row.satelliteImg,
                  "preview-src-list": [scope.row.satelliteImg]
                }
              }) : _c('span', [_vm._v(" - ")])]
            }
          }], null, false, 2443157081)
        }) : _vm._e(), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "createTime",
            "label": "创建时间",
            "width": "160",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(" " + _vm._s(_vm.dateTran(scope.row.createTime)) + " ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "生成耗时",
            "width": "100",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(
                scope.row.generationEndTime && scope.row.generationStartTime
              ) ? _c('span', [_vm._v("\n            " + _vm._s(_vm.formatDuration(
                scope.row.generationEndTime - scope.row.generationStartTime
              )) + "\n          ")]) : _c('span', [_vm._v(" - ")])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "prop": "generationState",
            "label": "状态",
            "width": "80",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.generationState === -1) ? _c('span', [_vm._v("待提交")]) : (scope.row.generationState === 0) ? _c('span', [_vm._v("生成中")]) : (scope.row.generationState === 1) ? _c('span', [_vm._v("完成")]) : (scope.row.generationState === 3) ? _c('span', [_vm._v("错误")]) : (scope.row.generationState === 4) ? _c('span', [_vm._v("取消")]) : _c('span', [_vm._v("-")])]
            }
          }])
        }), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "prop": "prompt",
            "label": "提示词",
            "min-width": "180",
            "show-overflow-tooltip": ""
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.prompt || "-"))])]
            }
          }], null, false, 1415799279)
        }) : _vm._e(), _vm._v(" "), (_vm.loginType == '0') ? _c('el-table-column', {
          attrs: {
            "label": "操作",
            "width": "50"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', {
                staticClass: "operate"
              }, [_c('el-tooltip', {
                attrs: {
                  "effect": "dark",
                  "content": "详情",
                  "placement": "top"
                }
              }, [_c('span', {
                staticClass: "dnnfont iconfile-search",
                on: {
                  "click": function($event) {
                    return _vm.handleDetail(scope.row)
                  }
                }
              })])], 1)]
            }
          }], null, false, 187938449)
        }) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
          attrs: {
            "title": "生图详情",
            "visible": _vm.dialogVisible,
            "width": "50%",
            "top": "5vh"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        }, [_c('el-row', {
          attrs: {
            "gutter": 20
          }
        }, [_c('el-form', {
          staticClass: "demo-ruleForm login-container",
          attrs: {
            "label-width": "100px"
          }
        }, [_c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "企业:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.companyname || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "用户名:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.userName || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "角色:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.membershipName || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "创建时间:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.dateTran(_vm.detail.createTime)) + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "图片大小:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.resolution || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "提示词:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.prompt || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 24
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "生图记录id:"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.detail.generationId || "-") + "\n            ")])], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "通道图:"
          }
        }, [(_vm.detail.modelImgThumbnail || _vm.detail.modelImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.modelImgThumbnail || _vm.detail.modelImg,
            "preview-src-list": [_vm.detail.modelImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "原图:"
          }
        }, [(_vm.detail.originalImgThumbnail || _vm.detail.originalImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.originalImgThumbnail || _vm.detail.originalImg,
            "preview-src-list": [_vm.detail.originalImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "叠加优化图:"
          }
        }, [(
          _vm.detail.optimizationImgThumbnail || _vm.detail.optimizationImg
        ) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.optimizationImgThumbnail || _vm.detail.optimizationImg,
            "preview-src-list": [_vm.detail.optimizationImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1), _vm._v(" "), _c('el-col', {
          attrs: {
            "span": 12
          }
        }, [_c('el-form-item', {
          attrs: {
            "label": "原图优化图:"
          }
        }, [(_vm.detail.satelliteImgThumbnail || _vm.detail.satelliteImg) ? _c('el-image', {
          staticStyle: {
            "height": "150px",
            "width": "auto"
          },
          attrs: {
            "src": _vm.detail.satelliteImgThumbnail || _vm.detail.satelliteImg,
            "preview-src-list": [_vm.detail.satelliteImg]
          }
        }) : _c('span', [_vm._v(" - ")])], 1)], 1)], 1)], 1)], 1)]
      },
      proxy: true
    }, {
      key: "ft",
      fn: function() {
        return [_c('el-col', {
          staticClass: "toolbar",
          attrs: {
            "span": 24
          }
        }, [_c('el-pagination', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "layout": "total, sizes, prev, pager, next",
            "page-sizes": [10, 20, 30, 50, 100],
            "current-page": _vm.pageNumber,
            "page-size": _vm.pageSize,
            "total": _vm.total
          },
          on: {
            "current-change": _vm.handleCurrentChange,
            "size-change": _vm.handleSizeChange
          }
        })], 1)]
      },
      proxy: true
    }])
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-57c21605"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/administrator/AIRilab/AIRilab.vue
// module id = 1798
// module chunks = 9